export enum Experiments {
  ProfileCardNewLayouts = 'specs.profileCardOOI.newLayouts',
  MemberBlockMember = 'specs.membersArea.MemberBlockMember',
  LoginInPopup = 'specs.membersArea.LoginInPopup',
  PrivateMemberIndicator = 'specs.membersArea.PrivateMemberIndicator',
  UiTpaImage = 'specs.profileCardOOI.imgMigration',
}
